import type { PortfolioCorrectionCommandData } from '@festina/unitlink-general-types/unitlink'
import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

const method = PortfolioSourcesEventsService.portfolioSourcesServicePostEvents

export const useCreatePortfolioCorrection = ({
  ownerId,
  tenantId,
}: PortfolioActionProps) =>
  useFestinaMutation({
    component: 'unitLink',
    roles:
      PortfolioSourcesEventsService.portfolioSourcesServicePostEvents_roles,
    isScenario: false,
    mutateFunction: async (arg: PortfolioCorrectionCommandData) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        requestBody: {
          _type: 'CreatePortfolioCommand',
          commandType: 'portfolioCorrection',
          commandData: arg,
        },
      })
    },
  })
// @BETA consider which other keys to invalidate once submit is successful
